module.exports = __webpack_public_path__ + "static/media/logo.7dfc2f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Menu/logo.png
// module id = 175
// module chunks = 0